import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Datenabfrage } from '../../domain/model/datenabfrage/datenabfrage';
import { DatenabfrageService } from '../../service/datenabfrage/datenabfrage.service';
import {
    NetzbetreiberAktiveDatenabfrageAssignment,
} from '../../domain/model/datenabfrage/netzbetreiber-aktive-datenabfrage-assignment';
import { ConfirmDialogService } from '../../service/common/confirm-dialog/confirm-dialog.service';

@Component({
    selector: 'tnb-teilnehmer-aktive-datenabfrage',
    templateUrl: './teilnehmer-aktive-datenabfrage.component.html',
    styleUrls: [
        './teilnehmer-aktive-datenabfrage.component.scss',
    ],
    standalone: false,
})
export class TeilnehmerAktiveDatenabfrageComponent {
    private datenabfrageService = inject(DatenabfrageService);
    private confirmDialogService = inject(ConfirmDialogService);

    @Input() aktiveDatenabfrage: Datenabfrage;
    @Input() isWestnetzAdmin: boolean;

    @Input() assignedNetzbetreiber: NetzbetreiberAktiveDatenabfrageAssignment[] = [];
    @Input() notAssignedNetzbetreiber: NetzbetreiberAktiveDatenabfrageAssignment[] = [];

    @Output() netzbetreiberAssignmentChanged = new EventEmitter<void>();

    netzbetreiberPanelOpenState = false;

    async removeNetzbetreiber(id: string) {
        let nb = this.assignedNetzbetreiber.find(n => n.id === id);
        if (nb && nb.hasAlreadySubmittedATS) {
            if (await this.confirmDialogService.confirm(
                'Der Netzbetreiber hat bereits einen Aufteilungsschluessel eingereicht, trotzdem löschen?',
                'Daten bereits eingereicht!',
                'primary',
                'Ja',
                'Nein',
                'innogy_picto_bin_c-check',
            )) {
                this.doRemoveNb(id);
            }
        } else {
            this.doRemoveNb(id);
        }
    }

    private doRemoveNb(id: string) {
        this.datenabfrageService.deleteAndRemoveAtsAndNetzbetreiberAssignment(id).subscribe(() => {
            this.netzbetreiberAssignmentChanged.emit();
        });
    }

    addNetzbetreiber(id: string) {
        this.datenabfrageService.addNetzbetreiberAssignment(id).subscribe(() => {
            this.netzbetreiberAssignmentChanged.emit();
        });
    }
}
